import { useEffect, useState } from 'react';

const useBottomCheck = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement.scrollTop || 0);

      // Check if the user is near the bottom of the page (adjust the threshold as needed)
      const isNearBottom = scrollTop + windowHeight >= documentHeight - 0;

      setIsAtBottom(isNearBottom);
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isAtBottom;
};

export default useBottomCheck;
